'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _chooseSeatHtml = require('./choose-seat.html');

var _chooseSeatHtml2 = _interopRequireDefault(_chooseSeatHtml);

var _chooseSeatController = require('./choose-seat.controller');

var _chooseSeatController2 = _interopRequireDefault(_chooseSeatController);

function routeConfig($stateProvider) {
	'ngInject';

	$stateProvider.state('app.public.btms.choose-seat', {
		url: '/choose-seat?subLineId&busId&date&returnId$returnBusId&returnDate&lang&u',
		template: _chooseSeatHtml2['default'],
		controller: _chooseSeatController2['default'],
		controllerAs: 'vm',
		'resolve': {
			'Currencies': function Currencies(CurrencyComponent) {
				'ngInject';

				return CurrencyComponent.fetchCurrencies();
			},
			'Discount': function Discount(DiscountComponent) {
				DiscountComponent.fetchDiscounts();
			},
			'SubLine': function SubLine($stateParams, SubLineComponent) {
				'ngInject';
				var isPublic = true;

				return SubLineComponent.fetchSubLine($stateParams.subLineId, $stateParams.busId, $stateParams.date, isPublic);
			},
			'ReturnSubLine': function ReturnSubLine($stateParams, SubLineComponent) {
				'ngInject';
				var isPublic = true;

				if ($stateParams.returnId) {
					return SubLineComponent.fetchSubLine($stateParams.returnId, $stateParams.returnBusId, $stateParams.returnDate, isPublic);
				}
			}
		}
	});
}

exports['default'] = routeConfig;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/public/main/choose-seat/choose-seat.route.js
 **/